import _extends from "@babel/runtime/helpers/esm/extends";
var _path;
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var SvgTelegram = function SvgTelegram(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    children: _path || (_path = /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M35 0H0v35h35V0Zm-9.275 10.918a.5.5 0 0 0-.666-.587l-14.968 5.82a.5.5 0 0 0-.042.913l2.566 1.283a.5.5 0 0 1 .25.29l1.513 4.537a.5.5 0 0 0 .875.142l1.937-2.582a.5.5 0 0 0-.114-.71L15.64 19.02a.5.5 0 0 1 .045-.847l3.011-1.659c.448-.246.933.258.67.695l-1.665 2.776a.5.5 0 0 0 .075.61l3.8 3.8a.5.5 0 0 0 .838-.232l3.311-13.245Z",
      fill: "currentColor"
    }))
  }));
};
export default SvgTelegram;